import dotenv from "dotenv"

dotenv.config()

export default  {
    aws_table_name: 'dailynews-api',
    aws_local_config: {
      //Provide details for local configuration
    },
    aws_remote_config: {
      accessKeyId: process.env.REACT_APP_ACCESS_KEY,
      secretAccessKey: process.env.REACT_APP_SECRETACCESS_KEY,
      region: 'ap-south-1',
      endpoint: "https://dynamodb.ap-south-1.amazonaws.com"
    }
};
